import {useGetConfigQuery} from '~/store/rtkQuery';

import {ManagePurchaselyDiscountTypes} from './ManagePurchaselyDiscountTypes';
import {ManageAskLunaAutoPublisher} from './ManageAskLunaAutoPublisher';

export const ManageConfig = () => {
  const {data, error, refetch} = useGetConfigQuery();

  if (error) {
    return (
      <div className="p-6">
        <div className="text-lg font-semibold mb-8">Manage Config</div>
        <p className="mt-4 text-red-600">{error?.message}</p>
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="text-lg font-semibold mb-8">Manage Config</div>

      <div className="flex flex-col gap-4">
        <div className="collapse collapse-plus bg-base-200">
          <input type="radio" name="config-accordion" />
          <div className="collapse-title text-xl font-medium">
            Purchasely Discount Types
          </div>
          <div className="collapse-content">
            <ManagePurchaselyDiscountTypes
              discountTypes={
                data?.sysAdminConfig.purchasely.discountTypes ?? {}
              }
              onConfigUpdated={refetch}
            />
          </div>
        </div>

        <div className="collapse collapse-plus bg-base-200">
          <input type="radio" name="config-accordion" />
          <div className="collapse-title text-xl font-medium">
            Ask Luna Auto Publisher
          </div>
          <div className="collapse-content">
            <ManageAskLunaAutoPublisher
              config={
                data?.sysAdminConfig.askLunaAutoPublish ?? { enabled: false }
              }
              onConfigUpdated={refetch}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
